export const sygnet = ['160 160', ``]